import { MAP_TYPES } from '@deck.gl/carto';

const BROWARDHFABOND_SOURCE_ID = 'browardHFABondSource';

const source = {
  id: BROWARDHFABOND_SOURCE_ID,
  type: MAP_TYPES.TABLE,
  connection: 'bmpo-smartmetro-09142026',
  data: `us-con-gcp-npr-0000424-011325.diamond.HFA_Bond_Assignments`,
};

export default source;
